export interface CacheConfig {
    redisHost?: string;
    redisPort?: number;
    redisPassword?: string;
    ssl?: boolean;
    ttl?: number;
    max?: number;
}